import React from 'react'
import { Divider, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useBossFilter } from 'hooks/useBossFilter'

const UNASSIGNED_BOSS_ID = 0
const ALL_VALUE = 'all'

export const BossFilterDropdown: React.FC = () => {
  const { t } = useTranslation()
  const { bosses, selectedBossId, setSelectedBossId, myIpPersonId, enabled } = useBossFilter()

  if (!enabled || bosses.length === 0) return null

  const bossName = (b: typeof bosses[0]) =>
    [b.firstName, b.surName].filter(Boolean).join(' ') || String(b.bossId)

  const value = selectedBossId !== undefined ? String(selectedBossId) : ALL_VALUE
  const myBoss = myIpPersonId ? bosses.find((b) => b.bossId === myIpPersonId) : null
  const unassigned = bosses.find((b) => b.bossId === UNASSIGNED_BOSS_ID)
  const otherBosses = bosses.filter(
    (b) => b.bossId !== myIpPersonId && b.bossId !== UNASSIGNED_BOSS_ID,
  )

  return (
    <FormControl size="small" variant="standard" style={{ minWidth: 180 }}>
      <InputLabel shrink>{t('BossFilter.label')}</InputLabel>
      <Select
        value={value}
        onChange={(e) => {
          const val = e.target.value as string
          setSelectedBossId(val === ALL_VALUE ? undefined : Number(val))
        }}
      >
        <MenuItem value={ALL_VALUE}>{t('BossFilter.all')}</MenuItem>
        {myBoss && <Divider />}
        {myBoss && (
          <MenuItem value={String(myIpPersonId)}>
            {t('BossFilter.myConsultants')} ({myBoss.count})
          </MenuItem>
        )}
        {otherBosses.length > 0 && <Divider />}
        {otherBosses.map((b) => (
          <MenuItem key={b.bossId} value={String(b.bossId)}>
            {bossName(b)} ({b.count})
          </MenuItem>
        ))}
        {unassigned && unassigned.count > 0 && <Divider />}
        {unassigned && unassigned.count > 0 && (
          <MenuItem value={String(UNASSIGNED_BOSS_ID)}>
            {t('BossFilter.unassigned')} ({unassigned.count})
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}
